<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="房间" property="roomId">
									<el-cascader
										placeholder="请选择房间"
										:options="TreeData"
										v-model="searchForm.roomId"
										:props="{ value: 'id', label: 'name', children: 'children' }"
										filterable
										clearable
										ref="myCascader"
									>
									</el-cascader>
								</el-form-item>
								
								<el-form-item label="日期范围" property="dateRange">
									<span>
										<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											unlink-panels
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											:picker-options="pickerOptions"
											@change="get_baobiao"
										/>
									</span>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="get_baobiao(true)">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools">
							<el-button type="primary" @click="exportExcel">导出</el-button>
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					>
						<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
						<el-table-column prop="buildingName" label="房间" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.buildingName}}-{{scope.row.roomNo}}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="roomNo" label="房间" align="center"></el-table-column> -->
						<el-table-column prop="dealTime" label="用量日期" align="center"></el-table-column>
						<!-- <el-table-column prop="inAmount" label="当日起码" align="center"></el-table-column>
						<el-table-column prop="outAmount" label="当日止码" align="center"></el-table-column> -->
						<el-table-column prop="dealAmount" label="用电量" align="center">
							<template slot-scope="scope">
								<!-- {{(scope.row.dealName == '配额消费' || scope.row.dealName == '消费' ) ? Number.isInteger(Number(scope.row.dealAmount)) ? scope.row.dealAmount : parseFloat(scope.row.dealAmount).toFixed(2) : '-'}} -->
								{{scope.row.dealName == '配额消费' ? Number.isInteger(Number(scope.row.dealAmount)) ? scope.row.dealAmount : parseFloat(scope.row.dealAmount).toFixed(2) : 
								 scope.row.dealName == '消费' ? Number.isInteger(Number(scope.row.dealAmount)) ? (scope.row.dealAmount / 0.57).toFixed(2) : (parseFloat(scope.row.dealAmount)/0.57).toFixed(2) : '-'}}
							</template>
						</el-table-column>
						<!-- <el-table-column prop="thisPrice" label="单价" align="center"></el-table-column> -->
						<!-- <el-table-column prop="dealName" label="类型" align="center"></el-table-column> -->
						<!-- <el-table-column prop="walletName" label="账户类型" align="center"></el-table-column> -->
						<el-table-column prop="dealName" label="类型" align="center">
							<template slot-scope="scope">
								<el-tag
									:type="getTagColor(scope.row.dealName)"
									effect="plain"
								>
								{{ scope.row.dealName }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="walletName" label="账户类型" align="center">
							<template slot-scope="scope">
								<el-tag
									:type="getTagColor(scope.row.walletName)"
									effect="plain"
								>
								{{ scope.row.walletName }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="inBalance" label="交易前" align="center">
							<template slot-scope="scope">
								<!-- {{scope.row.inBalance ? parseFloat(scope.row.inBalance).toFixed(2) : 0}} -->
								{{Number.isInteger(Number(scope.row.inBalance)) ? scope.row.inBalance : parseFloat(scope.row.inBalance).toFixed(2)}}
							</template>
						</el-table-column>
						<el-table-column prop="dealAmount" label="交易值" align="center">
							<template slot-scope="scope">
								{{Number.isInteger(Number(scope.row.dealAmount)) ? scope.row.dealAmount : parseFloat(scope.row.dealAmount).toFixed(2) }}
								<!-- {{scope.row.dealName == '消费' ? (parseFloat(scope.row.dealAmount)*0.57).toFixed(2) : Number.isInteger(Number(scope.row.dealAmount)) ? scope.row.dealAmount : parseFloat(scope.row.dealAmount).toFixed(2) }} -->
							</template>
						</el-table-column>
						<el-table-column prop="outBalance" label="交易后" align="center">
							<template slot-scope="scope">
								<!-- {{scope.row.outBalance ? parseFloat(scope.row.outBalance).toFixed(2) : 0}} -->
								{{Number.isInteger(Number(scope.row.outBalance)) ? scope.row.outBalance : parseFloat(scope.row.outBalance).toFixed(2)}}
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="操作时间" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="nickname" label="操作员" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="dealInfo" label="备注" align="center" show-overflow-tooltip></el-table-column>

						<!-- <el-table-column prop="lastBalance" label="个账余额" sortable align="center">
							<template slot-scope="scope">
								<span>{{scope.row.lastBalance ? parseFloat(scope.row.lastBalance).toFixed(4) : 0}}</span>
							</template>
						</el-table-column> -->

						<!-- <el-table-column
						  prop="icon"
						  fixed="right"
						  align="center"
						  label="操作">
							<template slot-scope="scope">
								<el-button v-if="scope.row.personMoney > 0" type="text" @click="viewHandle(scope.row)">扣费详情</el-button>
							</template>
						</el-table-column> -->

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!-- 查看入住人员、交易记录 -->
		<el-dialog
		  :title="dialog.title"
		  :visible.sync="dialog.dialogVisible"
		  width="70%"
		  top="10vh"
		  :before-close="handleCloseDialog"
		>
		  	<el-table
				ref="dialogTable"
				:data="dialog.tableData"
				:span-method="arraySpanMethod"
				tooltip-effect="dark"
				border
				stripe
			>
				<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
				<el-table-column  prop="personName" label="姓名" show-overflow-tooltip align="center"></el-table-column>
				<el-table-column  prop="personNo" label="学号" align="center"></el-table-column>
				<el-table-column  prop="inBalance" label="扣前余额" align="center">
					<template slot-scope="scope">
						{{scope.row.inBalance ? parseFloat(scope.row.inBalance).toFixed(4) : 0}}
					</template>
				</el-table-column>
				<el-table-column  prop="" label="总扣费" align="center">
					<template>
						{{clickRow.personMoney ? parseFloat(clickRow.personMoney).toFixed(4) : 0}}
					</template>
				</el-table-column>
				<el-table-column  prop="dealMoney" label="分摊扣费金额" align="center">
					<template slot-scope="scope">
						{{scope.row.dealMoney ? parseFloat(scope.row.dealMoney).toFixed(4) : 0}}
					</template>
				</el-table-column>
				<el-table-column  prop="outBalance" label="个人余额（元）" align="center">
					<template slot-scope="scope">
						{{scope.row.outBalance ? parseFloat(scope.row.outBalance).toFixed(4) : 0}}
					</template>
				</el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer" style="margin-top: 20px;text-align: center;">
				<el-button @click="handleCloseDialog">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
// import { getMomentList, getStutList, getTree, exportRoomtList } from '@/apis/orange'
import { mapGetters, mapActions } from 'vuex';

export default {
	name: "Baobiao",	// 报表
	data() {
		return {
			nowDate: '',
			loading: false,

			searchForm: {},
			dateRange: [],
			dateRangeMoren: [],		// 默认日期范围
			TreeData: [
				{id: 0, name: '数据加载中' }
			],

			total: 0,
			size: 10,
			current: 1,

			clickRow: {},
			dialog: {
				total: 0,
				size: 10,
				current: 1,

				title: '订单扣费详情',
				dialogVisible: false,
				getParams: {},
				dateRange: [],
				tableData: [],
			},

			tableData: [],

			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	computed: {
		...mapGetters('treeData', ['treeData']),
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		let t = new Date()
		this.fetchTreeData().then(data => {
			this.TreeData = data
		});
		// let startDate = '2024-12-01'
		let startDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-01'
		let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		this.nowDate = endDate
		this.dateRange = [startDate, endDate]
		this.dateRangeMoren = [startDate, endDate]
		this.get_baobiao()
		// this.getLocationTree()
	},
	methods: {
		...mapActions('treeData', ['fetchTreeData']),
		resetSearchForm() {
			this.current = 1
			this.searchForm = {}
			this.get_baobiao()
		},
		getTagColor(name) {
			switch (name) {
				case '房间配额': return 'primary'
				case '配额补贴': return 'primary'
				case '配额扣除': return 'danger'
				case '手工充值': return 'primary'
				case '手工扣款': return 'danger'
				case '房间账户': return 'success'
				case '配额消费': return 'success'
				case '配额充值': return 'primary'
				case '消费': return 'warning'
				default: return 'info'
			}
		},
		exportExcel() {
			const loading = this.$loading({
				text: '加载中...',
			});
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				// let floo = searchObj.roomId[ searchObj.roomId.length - 2 ] ? searchObj.roomId[ searchObj.roomId.length - 2 ].toString() : false
				// // searchObj.roomId = floo ? room.split(floo)[1] : room
				// if (floo) {
				// 	searchObj.roomId = room.split(floo)[1]
				// } else if (room != 0) {
				// 	searchObj.roomId = room
				// }
				searchObj.roomId = room
			} else {
				delete searchObj.roomId
			}
			exportRoomtList({...searchObj, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]}).then(res => res.data).then(res => {
				loading.close()
				// console.log(res);
				if (res.code == 200) {
					if (res.data.length) {
						let excelData = res.data.map((it, index) => ({index: index + 1, mc: `${it.buildingName}-${it.roomNo}`, time: it.dealTime, 
							ds: it.dealName == '配额消费' ? Number.isInteger(Number(it.dealAmount)) ? it.dealAmount : parseFloat(it.dealAmount).toFixed(2) : 
								it.dealName == '消费' ? Number.isInteger(Number(it.dealAmount)) ? (it.dealAmount/0.57).toFixed(2) : (parseFloat(it.dealAmount)/0.57).toFixed(2) : '',
							lx: it.dealName, type: it.walletName, 
							prePe: it.walletName=='房间配额'? Number.isInteger(Number(it.inBalance)) ? it.inBalance : parseFloat(it.inBalance).toFixed(2):'',
							pe: it.walletName=='房间配额'? Number.isInteger(Number(it.dealAmount)) ? it.dealAmount : parseFloat(it.dealAmount).toFixed(2):'',
							overPe: it.walletName=='房间配额'? Number.isInteger(Number(it.outBalance)) ? it.outBalance : parseFloat(it.outBalance).toFixed(2):'',
							preYe: it.walletName=='房间账户'? Number.isInteger(Number(it.inBalance)) ? it.inBalance : parseFloat(it.inBalance).toFixed(2):'',
							ye: it.walletName=='房间账户'? it.dealName == '消费' ? (parseFloat(it.dealAmount)).toFixed(2) : Number.isInteger(Number(it.dealAmount)) ? it.dealAmount : parseFloat(it.dealAmount).toFixed(2) : '',
							overYe: it.walletName=='房间账户'? Number.isInteger(Number(it.outBalance)) ? it.outBalance : parseFloat(it.outBalance).toFixed(2):'',
							czTime: it.createTime, nickname:it.nickname, dealInfo:it.dealInfo
						}))
						// let excelData = res.data.map((it, index) => ({index: index + 1, mc: `${it.buildingName}-${it.roomNo}`, time: it.dealTime, 
						// 	ds: (it.dealName == '配额消费' || it.dealName == '消费' ) ? Number.isInteger(Number(it.dealAmount)) ? it.dealAmount : parseFloat(it.dealAmount).toFixed(2) : '',
						// 	lx: it.dealName, type: it.walletName, 
						// 	prePe: it.walletName=='房间配额'? Number.isInteger(Number(it.inBalance)) ? it.inBalance : parseFloat(it.inBalance).toFixed(2):'',
						// 	pe: it.walletName=='房间配额'? Number.isInteger(Number(it.dealAmount)) ? it.dealAmount : parseFloat(it.dealAmount).toFixed(2):'',
						// 	overPe: it.walletName=='房间配额'? Number.isInteger(Number(it.outBalance)) ? it.outBalance : parseFloat(it.outBalance).toFixed(2):'',
						// 	preYe: it.walletName=='房间账户'? Number.isInteger(Number(it.inBalance)) ? it.inBalance : parseFloat(it.inBalance).toFixed(2):'',
						// 	ye: it.walletName=='房间账户'? it.dealName == '消费' ? (parseFloat(it.dealAmount)*0.57).toFixed(2) : Number.isInteger(Number(it.dealAmount)) ? it.dealAmount : parseFloat(it.dealAmount).toFixed(2) : '',
						// 	overYe: it.walletName=='房间账户'? Number.isInteger(Number(it.outBalance)) ? it.outBalance : parseFloat(it.outBalance).toFixed(2):'',
						// 	czTime: it.createTime, nickname:it.nickname, dealInfo:it.dealInfo
						// }))
                        this.getExcel(excelData)
					} else {
						this.$message({
							type: 'error',
							message: "没有可导数据"
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '房间', '用量日期', '用电量', '类型', '账户类型', '交易前配额' , '交易配额', '交易后配额', '交易前余额' , '交易金额', '交易后余额', '操作时间', '操作员', '备注']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `房间交易记录${this.nowDate}.xlsx`)
        },
		getLocationTree() {
			getTree().then(res => res.data).then(res => {
				this.TreeData = this.adjustCascaderData(res.data)
			})
		},
		adjustCascaderData(data) {
			return data.map(item => {
				if (item.children && item.children.length == 0) {
					delete item.children; // 删除空的 children 数组
				} else {
					item.children = this.adjustCascaderData(item.children);
				}
				return item;
			});
		},
		arraySpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex ===4) { // 只对第4列进行合并
				if (rowIndex === 0) {
				return {
					rowspan: this.getRowSpan(row.category),
					colspan: 1,
				};
				} else {
					const prevRow = this.dialog.tableData[rowIndex - 1];
					if (prevRow.category === row.category) {
						return {
							rowspan: 0,
							colspan: 0,
						};
					} else {
						return {
							rowspan: this.getRowSpan(row.category, rowIndex),
							colspan: 1,
						};
					}
				}
			}
		},
		getRowSpan(category, startIndex = 0) {
			let count = 0;
			for (let i = startIndex; i < this.dialog.tableData.length; i++) {
				if (this.dialog.tableData[i].category === category) {
					count++;
				} else {
					break;
				}
			}
			return count;
		},
		handleCloseDialog() {
			this.dialog.dialogVisible = false
		},
		viewHandle(row) {
			this.clickRow = row
			const loading = this.$loading({
				text: '加载中...',
			});
			this.dialog.title = `扣费详情（${row.buildingName}-${row.roomNo}  /  ${row.payTime}）`
			getStutList({
				// current: this.dialog.current, size: this.dialog.size, 
				beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
				endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1],
				orderId: row.payOrderId
			}).then(res => res.data).then(res => {
				this.dialog.dialogVisible = true
				loading.close()
				this.dialog.tableData = res.data.records
				this.dialog.total = res.data.total
				this.dialog.loading = false
			})
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},

		handleSizeChange(val) {
			this.size = val
			this.get_baobiao()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_baobiao()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		get_baobiao(resetPage = false) {
			if (resetPage) {
				this.current = 1
			}
			this.loading = true
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				// let floo = searchObj.roomId[ searchObj.roomId.length - 2 ] ? searchObj.roomId[ searchObj.roomId.length - 2 ].toString() : false
				// searchObj.roomId = floo ? room.split(floo)[1] : room
				// if (floo) {
				// 	searchObj.roomId = room.split(floo)[1]
				// } else if (room != 0) {
				// 	searchObj.roomId = room
				// }
				searchObj.roomId = room
			} else {
				delete searchObj.roomId
			}
			getMomentList({current: this.current, size: this.size, ...searchObj, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			}).then(res => res.data).then(res => {
				// console.log(res);
				this.tableData = res.data.records
				this.total = res.data.total
				this.loading = false
			})
		},

	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>